import axios from 'axios';

import { getData } from '@feature/utils';

import { UniversityConfig, UniversityConfigRequest } from './UniversityConfigTypes';

export function get() {
  return axios.get<UniversityConfig>('/university-config').then(getData);
}

export function update(request: UniversityConfigRequest) {
  return axios.put<UniversityConfig>('/university-config', request).then(getData);
}
